import { Button, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { useScreenSize } from '../hooks/useScreenSize'
import { DailyBonusIcon } from './assets/DailyBonusIcon'

interface IProps {
    isActive: boolean
    onClick: () => void
}

const DailyBonusButton: React.FC<IProps> = ({ isActive, onClick }) => {
    const { isMobile } = useScreenSize()
    const [tooltipOpen, setTooltipOpen] = useState<boolean>(isActive)

    useEffect(() => {
        if (tooltipOpen) {
            setTimeout(() => {
                setTooltipOpen(false)
            }, 3000)
        }
    }, [tooltipOpen])

    return (
        <Tooltip title="Daily Bonus Ready!" placement="bottom" arrow open={tooltipOpen}>
            {isMobile ? (
                <Button
                    animated={Boolean(isActive)}
                    badge={isActive}
                    endIcon={<DailyBonusIcon />}
                    color="secondary"
                    size="medium"
                    variant="contained"
                    onlyIcon
                    onClick={onClick}
                />
            ) : (
                <Button
                    animated={Boolean(isActive)}
                    badge={isActive}
                    endIcon={<DailyBonusIcon />}
                    color="secondary"
                    variant="contained"
                    size="large"
                    onClick={onClick}
                >
                    Daily Bonus
                </Button>
            )}
        </Tooltip>
    )
}

DailyBonusButton.displayName = 'DailyBonusButton'

export default DailyBonusButton
